import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { Container, Col, Row, Card } from 'react-bootstrap';
import Layout from '../components/layout.js';
import Image from '../components/image.js';
export const _frontmatter = {
  "layout": "home",
  "title": "Home",
  "order": 1,
  "threejs": true
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = props => {
  return <Layout {...props} icon="home" />;
};
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Welcome!`}</h2>
    <p>{`Hello, I'm Zeng Dai. I do web and graphics, by writing code. I picture myself: a problem solver, builder, and truth seeker. I'm also an ex-game developer and an enthusiastic learner of every technology within my radar. Just love the feeling of learning and building cool stuff combo with challenges. `}</p>
    <p>{`As you might find out, I have broad interest which spans from time to time: from math/statistics to computer science, from 3D real time rendering to web dev, from big data visualization to deep learning. All these experiences make me a unique person (knowing both arcane & dark magic😉 or nothing) to handle a wide range of topics in computer science. In my view, new technologies and buzzwords flies by, yet coding and learning remains unchanged. My recent interest lands in Gen AI application for our daily life and I believe building its tech for everyone is the next big matter. `}</p>
    <Image filename="home-bg.png" className="float-right-photo" style={{
      width: '15rem'
    }} mdxType="Image" />
    <p>{`Feel free to explore my pages! It's basically another view of my messy markdown wiki about code, reading, research, technology, and life.`}</p>


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      